// Adapter: maps an events row onto the shared .ics payload (spa/src/helpers/ics.js), which
// owns the RFC 5545 encoding — escaping, floating DATE-TIMEs, the DTSTAMP instant and the
// download mechanics. The builder used to live here; it moved out when recruitment's
// interview slots needed the same file format and the landing page needed to offer one for
// a row that isn't an event.
//
// `event_start_timestamp`/`event_end_timestamp` are wall-clock text straight off v_event —
// pass them through untouched, never via `new Date()`, or the shifted-by-your-offset bug is
// back.
export const icsFromEvent = (event) => ({
  uid:          `${event.event_uuid || event.event_slug}@kayenta-apps`,
  title:        event.event_title,
  start:        event.event_start_timestamp,
  end:          event.event_end_timestamp,
  location:     event.event_location,
  description:  event.event_description,
  url:          event.event_url,
  filenamePart: event.event_slug || 'event',
})
